var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFee(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4797 11.7209C13.4212 11.5553 13.3308 11.4047 13.216 11.2765C12.9719 11.0037 12.6171 10.832 12.2222 10.832H11.1902C10.5329 10.832 10 11.3649 10 12.0222C10 12.5815 10.3894 13.0654 10.9358 13.1849L12.5072 13.5286C13.1193 13.6625 13.5556 14.205 13.5556 14.8315C13.5556 15.5679 12.9586 16.1654 12.2222 16.1654H11.3333C10.7528 16.1654 10.2589 15.7943 10.0759 15.2765",
    stroke: "#61676B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7773 10.8333V9.5",
    stroke: "#61676B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7773 17.5013V16.168",
    stroke: "#61676B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7144 7.07031H8.85725C8.25104 7.07031 7.66966 7.31113 7.241 7.73978C6.81235 8.16844 6.57153 8.74982 6.57153 9.35603V21.9275L9.42868 20.2132L12.2858 21.9275L15.143 20.2132L18.0001 21.9275V8.7846C18.0001 8.32994 18.1807 7.89391 18.5022 7.57242C18.8237 7.25092 19.2597 7.07031 19.7144 7.07031C20.169 7.07031 20.6051 7.25092 20.9266 7.57242C21.2481 7.89391 21.4287 8.32994 21.4287 8.7846V12.7846H18.0001",
    stroke: "#61676B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFee);
export default __webpack_public_path__ + "static/media/fee.46766242aa722b5cb9a60a4c1f8fc174.svg";
export { ForwardRef as ReactComponent };